// extracted by mini-css-extract-plugin
export default {"aboutUs":"aboutus_aboutUs__9NJEY","aboutusContent":"aboutus_aboutusContent__W3HQK"};